import { View } from 'lucide-react';

import {
  ReviewRequestTerminationDialog,
  ReviewRequestTerminationTooltip,
} from 'src/containers/SoftwareEscrow/Termination';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { Button } from '@/components/ui/button';

const ReviewRequestTermination = () => {
  const {
    softwareEscrow: { escrowTermination },
  } = useSoftwareEscrow();

  if (escrowTermination?.policy.accept)
    return (
      <ReviewRequestTerminationDialog
        triggerNode={
          <Button>
            <View />
            Review request
          </Button>
        }
      />
    );

  return (
    <ReviewRequestTerminationTooltip
      triggerNode={
        <div>
          <Button disabled>
            <View />
            Review request
          </Button>
        </div>
      }
    />
  );
};

export default ReviewRequestTermination;
